__turbopack_context__.v({
  "counter": "CurrencyInput-module-scss-module__N_YToW__counter",
  "error": "CurrencyInput-module-scss-module__N_YToW__error",
  "errorMsg": "CurrencyInput-module-scss-module__N_YToW__errorMsg",
  "field": "CurrencyInput-module-scss-module__N_YToW__field",
  "fieldDescription": "CurrencyInput-module-scss-module__N_YToW__fieldDescription",
  "input": "CurrencyInput-module-scss-module__N_YToW__input",
  "inputContent": "CurrencyInput-module-scss-module__N_YToW__inputContent",
  "inputElement": "CurrencyInput-module-scss-module__N_YToW__inputElement",
  "label": "CurrencyInput-module-scss-module__N_YToW__label",
  "labelWrapper": "CurrencyInput-module-scss-module__N_YToW__labelWrapper",
  "required": "CurrencyInput-module-scss-module__N_YToW__required",
  "secondary": "CurrencyInput-module-scss-module__N_YToW__secondary",
  "sub": "CurrencyInput-module-scss-module__N_YToW__sub",
});
